"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Astrix16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "astrix-16", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("polygon", { id: "*", fill: "#000000", fillRule: "nonzero", points: "8.8372093 12 7.1627907 12 7.29568106 9.17041801 4.85049834 10.6881029 4 9.29903537 6.57807309 7.98713826 4 6.70096463 4.85049834 5.31189711 7.29568106 6.82958199 7.1627907 4 8.8372093 4 8.70431894 6.82958199 11.1495017 5.31189711 12 6.70096463 9.42192691 7.98713826 12 9.29903537 11.1495017 10.6881029 8.70431894 9.17041801" })));
}
function Astrix16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Astrix16Svg, Object.assign({}, svgProps)));
}
exports.default = Astrix16;
//# sourceMappingURL=Astrix16.js.map